import React, { Component } from 'react';
import { getUuidFromUrl, resizeTo } from '../../../lib/ucImage';
import { img } from '../../../lib/brand';
import styles from './styles.module.less';

var blogFallBack1 = img('BlogFallBack1.jpg');
var blogFallBack2 = img('BlogFallBack2.jpg');
var blogFallBack3 = img('BlogFallBack3.jpg');

class PreviewBlogs extends Component {
   constructor(props) {
      super(props);
      this.state = {
         allBlogs: this.props.blogs,
         blogs: this.props.blogs.slice(0, 8)
      };
      this.ViewMore = this.ViewMore.bind(this);
   }

   getBlogImg = blog => {
      const { image, bloghero } = blog;
      let img = '';

      if (image) {
         img = resizeTo(getUuidFromUrl(image), 1000);
      } else if (bloghero) {
         img = resizeTo(getUuidFromUrl(bloghero), 1000);
      } else {
         [blogFallBack1, blogFallBack2, blogFallBack3][Math.floor(Math.random() * 3)];
      }
      return img;
   };

   renderImg = blog => {
      const { photoAlignment = 'center' } = blog;
      let backgroundPosition = photoAlignment || 'center';
      let heroStyle = {
         backgroundImage: `url("${this.getBlogImg(blog)}")`,
         backgroundPosition
      };
      return <div className={styles.hero} style={heroStyle} />;
   };

   renderBlogs = (blog, index) => {
      //get date
      let d = new Date(blog.date.toString());
      let date = d.toLocaleDateString('en-US', {
         month: 'long',
         day: 'numeric',
         year: 'numeric'
      });

      return (
         <a href={blog.slug} className={styles.blogItem} key={blog.id}>
            {this.renderImg(blog)}
            <div className={styles.content}>
               <div className={styles.date}>{date}</div>
               <div className={styles.author}>{`by ${blog.author.profile.name}`}</div>
               <div className={styles.blogTitle}>{blog.title}</div>
            </div>
         </a>
      );
   };
   renderLargeBlogs = (blog, index) => {
      //get date
      let d = new Date(blog.date.toString());
      let date = d.toLocaleDateString('en-US', {
         month: 'long',
         day: 'numeric',
         year: 'numeric'
      });

      return (
         <a className={styles.blogItemLarge} key={blog.id} href={blog.slug}>
            {this.renderImg(blog)}
            <div className={styles.content}>
               <div className={styles.date}>{date}</div>
               <div className={styles.author}>{`by ${blog.author.profile.name}`}</div>
               <div className={styles.blogTitle}>{blog.title}</div>
            </div>
         </a>
      );
   };

   ViewMore() {
      let { blogs, allBlogs } = this.state;
      if (allBlogs.length > blogs.length) {
         blogs = allBlogs.slice(0, blogs.length + 18);
         this.setState({ blogs });
      }
   }

   render() {
      const { blogs, allBlogs } = this.state;
      let moreBlogs = blogs.slice(5);
      let viewMoreCounter = Math.ceil(moreBlogs.length / 3);
      let rows = [];
      for (let i = 0; i < viewMoreCounter; i++) {
         rows.push(
            moreBlogs.slice(i * 3).length > 2 ? (
               <div className={styles.blogPanel} key={i}>
                  {moreBlogs.slice(i * 3, i * 3 + 3).map(this.renderBlogs)}
               </div>
            ) : (
               <div className={styles.blogPanel} key={i}>
                  {moreBlogs.slice(i * 3, i * 3 + 2).map(this.renderLargeBlogs)}
               </div>
            )
         );
      }

      return (
         <>
            {blogs.length > 2 ? (
               <div className={styles.blogPanel}>{blogs.slice(0, 3).map(this.renderBlogs)}</div>
            ) : (
               <div className={styles.blogPanel}>{blogs.slice(0, 2).map(this.renderLargeBlogs)}</div>
            )}
            <div className={styles.blogPanel}>{blogs.slice(3, 5).map(this.renderLargeBlogs)}</div>

            {rows}
            {blogs.length !== allBlogs.length && (
               <div className={styles.ViewMore}>
                  <div onClick={this.ViewMore}>View More</div>
               </div>
            )}
         </>
      );
   }
}

export default PreviewBlogs;
